<template>
    <div class="box">
        <div class="row">
            <div class="col-md-12 m-3">
                <h3>Special requests</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <form class="form wrap form--inline" @submit.prevent="updateSpecialRequest">
                    <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(33% - 1rem);">
                        <textarea v-model="booking.special_request"></textarea>
                    </div>
                    <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(33% - 1rem);">
                        <button class="button mt-1">
                            <span>Update</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div> 
</template>

<script>
export default {
    name: 'SpecialRequest',
    props: {
        booking:Object
    },
    methods: {
        updateSpecialRequest() {
            this.$store.dispatch('setLoadStatus')
            fetch(`${this.$api}update-booking/update-special-request`, {
                method: 'POST',
                body: JSON.stringify({
                    holiday_booking_id: this.$route.params.id,
                    special_req: this.booking.special_request
                }),
                headers: {
                    "Content-Type": "application/json",
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
                })
                .then(res => res.json())
                .then(response => {
                    this.$store.dispatch('setLoadStatus')
                    if (response.status) {
                        this.$notify({
                            type: 'success',
                            title: response.message
                        });
                    }     
                })
                .catch((error) => {
                    this.$store.dispatch('setLoadStatus')
                    console.log(error);
                })
        }
    }
}
</script>

<style lang="scss" scoped>

</style>